export default __webpack_public_path__ + "static/media/staff4.017d0216.jpeg";